export default __webpack_public_path__ + "static/media/fallback_item.3aaa83af.png";